import React, { useState, useRef, useEffect } from 'react';
import { BlockUI } from 'primereact/blockui';
import { Button } from 'primereact/button';
import { useNavigate, Link } from "react-router-dom";
import AdminServiciosAPI from '../servicios/AdminServicios';
import { Toast } from 'primereact/toast';
import Constantes from '../comun/Constantes';
import Config from '../comun/Config';
import { Image } from 'primereact/image';
import { RadioButton } from 'primereact/radiobutton';
import './productos.css';

const ProductoItem = ({item}) => {
    const [tipoRecoleccion, setTipoRecoleccion] = useState(0)
    const especificaciones = JSON.parse(item.especificaciones)
    const navigate = useNavigate();
    const variante=Date.parse(item.fecha_actualizacion?item.fecha_actualizacion:item.fecha_creacion)

    const parametros = JSON.parse(localStorage.getItem(Constantes.LOCALPARAMETROS))

    const conValor = (servicio) => {
        const valorext = (servicio.precio_extra && servicio.precio_extra>0)?`$ ${servicio.precio_extra} `:''
        return (<><div className="precio">${servicio.precio}</div>
        <div>({valorext}{parametros[Constantes.PARAMETRO_EXTRATON].valor_corto})</div>
        <strong>Maximum Weight:</strong> {especificaciones.weight}</>)
    }

    const sinValor = () => { return (<>
        <div className="precio">{parametros[Constantes.PARAMETRO_NOFEE].valor_corto}</div>
        <strong>Minimum Weight:</strong> {especificaciones.min_weight?especificaciones.min_weight:especificaciones.weight}</>
    )}

    return (
        <div className='card mb-4 bg-light-subtle cardproducto'>
            <div className='card-body'>
                <div className='row'>
                    <div className='col-md-2 text-center'>
                        <Image src={`${Config.urlImg}${item.id_empresa}/imagenes/${item.imagenes}_tumb.jpg?t=${variante}`} 
                            zoomSrc={`${Config.urlImg}${item.id_empresa}/imagenes/${item.imagenes}.jpg?t=${variante}`}
                            preview
                            imageClassName='img-fluid' alt={item.nombre}/>
                        <Link to={`/producto-details/${item.id}`} className='moreinfolink'>More Info</Link>
                    </div>
                    <div className='col-md-3 mt-3'>
                        <h2>{item.nombre}</h2>
                        <div>
                            <strong>Dimensions:</strong> {especificaciones.size}<br/>
                        </div>
                    </div>
                    <div className='col-md-3 mt-3'>
                        {item.servicios.map((tr,i)=>{
                            return (
                                <div key={`tr-${item.id}-${i}`} className="flex align-items-center tiporecoleccion">
                                    <RadioButton inputId={`tr-${item.id}-${i}`} value={i} onChange={(e) => setTipoRecoleccion(e.value)} checked={tipoRecoleccion === i} />
                                    <label htmlFor={`tr-${item.id}-${i}`} className="ml-2">{tr.label}</label>
                                </div>
                            )
                        })}
                    </div>
                    <div className='col-md-4 cardprecioproducto'>
                        <div className='row'>
                            <div className='col-md-8 text-center mt-3'>
                                {item.servicios[tipoRecoleccion].precio==0?sinValor():conValor(item.servicios[tipoRecoleccion])}
                            </div> 
                            <div className='col-md-4 text-center actionbuttons'>
                                {
                                    Object.keys(Constantes.subservicios).map((s,i) => {
                                        return (item.subservicio.includes(s) && <Button key={`btn${i}`} 
                                            onClick={()=>{navigate(`/booking/${item.id}/${item.servicios[tipoRecoleccion].tipo}/${Constantes.subservicios[s].name}`)}} 
                                            className='boton-booking mt-2 w-100'
                                            style={Constantes.subservicios[s].estilos}
                                            size="large" 
                                            label={s}
                                            severity='danger'/>)
                                    })
                                }
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    )
}

const Productos = () => {
    const [cargando, setCargando] = useState(false);
    const [listado, setListado] = useState(null)
    const toast = useRef(null);

    const cargarDatos = async() => {
        const searchParams = new URLSearchParams(window.location.search);
        let idEmp = searchParams.has('id')?searchParams.get('id'):''
        if(idEmp!==''){
            localStorage.setItem(Constantes.LOCALUSUARIO, idEmp);
        }else if(localStorage.getItem(Constantes.LOCALUSUARIO)!==null){
            idEmp = localStorage.getItem(Constantes.LOCALUSUARIO)
        }
        let idUser = searchParams.has('us')?searchParams.get('us'):''
        if(idUser!==''){
            localStorage.setItem(Constantes.ADMINUSUARIO, idUser);
        }else if(localStorage.getItem(Constantes.ADMINUSUARIO)!==null){
            idUser = localStorage.getItem(Constantes.ADMINUSUARIO)
        }
        let token = searchParams.has('tk')?decodeURIComponent(searchParams.get('tk')):''
        if(token!==''){
            localStorage.setItem(Constantes.TOKENADMINUSUARIO, token);
        }else if(localStorage.getItem(Constantes.TOKENADMINUSUARIO)!==null){
            token = localStorage.getItem(Constantes.TOKENADMINUSUARIO)
        }
        //console.log('id',idEmp)
        
        if(idEmp  && idEmp!==''){
            setCargando(true)
            const response = await AdminServiciosAPI.getRegistro(`gettodos/${idEmp}/${idUser}`);
            if (response) {
                const respuesta = await response.json();
                //console.log('datos',respuesta)
                if(respuesta.error){
                    toast.current.show({severity:'warn', summary: 'Ups!', detail:respuesta.error, sticky: true});
                }else{
                    //console.log(respuesta)
                    let productos = respuesta.listado
                    let precios = respuesta.servicios
                    let i = 0
                    let j,k
                    localStorage.setItem(Constantes.LOCALPARAMETROS, JSON.stringify(respuesta.parametros));
                    //console.log(JSON.stringify(respuesta.parametros))
                    while(i < productos.length){
                        productos[i].servicio = JSON.parse(productos[i].servicio)
                        productos[i].subservicio = JSON.parse(productos[i].subservicio)
                        productos[i]['servicios']=[]
                        k=0
                        while(k < productos[i].servicio.length){
                            j = 0;
                            while(precios.length>0 && j<precios.length){
                                if(precios[j]['id_producto']===productos[i]['id'] && precios[j]['tipo']===productos[i].servicio[k]){
                                    productos[i]['servicios'].push({
                                        label: Constantes.tiposervicio[productos[i].servicio[k]],
                                        ...precios[j]
                                    })
                                    precios.splice(j,1)
                                    break;
                                }
                                j++;
                            }
                            k++;
                        }
                        i++;
                    }
                    //console.log('productos',productos)
                    setListado(productos)
                }
            }
            setCargando(false)
        }
    }

    useEffect(() => {
        cargarDatos()
    },[])

    return(
        <BlockUI blocked={cargando}>
            <Toast ref={toast} position="top-center" />
            <div>{
                listado && listado.map((p,i)=><ProductoItem item={p} key={p.id}/>)
            }</div>
        </BlockUI>
    )
}

export default Productos